import React from 'react'

export default function ({ children }) {
  // if (!window.chrome) {
  //   return (
  //     <div className='Login'>
  //       <div className='modal page center fit'>
  //         <h1>WebMango</h1>
  //         <div>
  //           <p>
  //             Sorry, WebMango currently only supports the Google Chrome Browser.
  //           </p>
  //           <div style={{textAlign: 'center'}}>
  //             <a className='button' href='https://www.google.com/chrome/'>Download Chrome</a>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   )
  // }
  return children
}



// WEBPACK FOOTER //
// ./src/components/BrowserCheck.js